import React from "react";
import SelectInput from "@/common/components/custom/SelectInput";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { ButtonWrapper } from "../../../AdminCommandPage.styled";
import { HINT_TEXT } from "../constants";
import { Hint } from "../ClearCsvImportedData.styled";

const ClearCsvForm = ({
  languagesOptions,
  selectedLanguage,
  setSelectedLanguage,
  handleCreateJobProcess,
}) => (
  <>
    <Hint>{HINT_TEXT}</Hint>
    <SelectInput
      width={140}
      selectWidth={300}
      name="Language"
      options={languagesOptions}
      selected={selectedLanguage}
      setSelected={setSelectedLanguage}
    />
    <ButtonWrapper>
      <CustomEditButton
        text="Clear CSV data"
        onClick={handleCreateJobProcess}
      />
    </ButtonWrapper>
  </>
);

export default ClearCsvForm;
